export default __webpack_public_path__ + "static/media/perfil.aa766bfe.jpg";